
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToastMessage, ToastOptions, ToastType } from './toast-models';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly maxVisibleToasts = 5;
  private readonly defaultOptions: Required<ToastOptions> = {
    duration: 5000,
    keepOnHover: true,
    closable: true,
    preventDuplicates: true
  };

  private toastsInternal: ToastMessage[] = [];
  private toastsSubject = new BehaviorSubject<ToastMessage[]>([]);
  toasts$ = this.toastsSubject.asObservable();

  show(type: ToastType, message: string, options: ToastOptions = {}): string {
    const finalOptions = { ...this.defaultOptions, ...options };

    if (finalOptions.preventDuplicates &&
      this.toastsInternal.some(t => t.message === message && t.type === type)) {
      return '';
    }

    const id = crypto.randomUUID();

    const toast: ToastMessage = {
      id,
      type,
      message,
      createdAt: Date.now(),
      options: finalOptions
    };

    this.toastsInternal.unshift(toast);

    // enforce queue limit
    if (this.toastsInternal.length > this.maxVisibleToasts) {
      this.toastsInternal = this.toastsInternal.slice(0, this.maxVisibleToasts);
    }

    this.toastsSubject.next([...this.toastsInternal]);
    return id;
  }

  remove(id: string) {
    this.toastsInternal = this.toastsInternal.filter(t => t.id !== id);
    this.toastsSubject.next([...this.toastsInternal]);
  }

  clear() {
    this.toastsInternal = [];
    this.toastsSubject.next([]);
  }
}
